import {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { Form, Button } from "reactstrap";
import { APILA } from "../../../../../../../config/apila";
import { APIMS } from "../../../../../../../config/apims";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import swal from "sweetalert";
import LoaderAction from "../../../../../../Loader/LoaderHome";
import "../../../../../../../index.css";
import ToastSuccess from "../../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export default function SwitchStudent(props) {
  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");

  const token = localStorage.getItem("token");
  const id_user = localStorage.getItem("id_admin");
  const output_id_user = id_user?.replace(/[|&;$%@"<>()+,]/g, "");

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  const { dataUpdate } = props;

  const [loading, setLoading] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);
  const [loadingLevel, setLoadingLevel] = useState(false);
  const [loadingKelas, setLoadingKelas] = useState(false);

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
    ysb_kelas_id: "",
  });

  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataLevel, setGetDataLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);

  /*
   * Menyimpan ID asli milik murid yang diklik.
   * Data ini digunakan agar pilihan pertama modal
   * sesuai dengan kelas murid saat ini.
   */
  const initialStudentData = useRef({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
    ysb_kelas_id: "",
  });

  /*
   * Bernilai true saat modal pertama dibuka.
   * Setelah user mengubah select secara manual,
   * nilainya akan menjadi false.
   */
  const isInitializing = useRef(false);

  const safeValue = (value) => {
    if (value === null || value === undefined) {
      return "";
    }

    return String(value);
  };

  const isSameValue = (valueA, valueB) => {
    return safeValue(valueA) === safeValue(valueB);
  };

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  /*
   * Mengambil semester dan cabang.
   */
  const fetchInit = useCallback(async () => {
    try {
      const [branchRes, semesterRes] = await Promise.all([
        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          fetchParams
        ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          fetchParams
        ),
      ]);

      if (branchRes?.status === 200) {
        const branches = branchRes.data?.data || [];

        setGetDataBranch(branches);

        /*
         * Apabila cabang murid tidak tersedia di API,
         * gunakan cabang pertama sebagai cadangan.
         */
        const currentBranchAvailable = branches.some((branch) =>
          isSameValue(
            branch?.branch_code,
            initialStudentData.current.ysb_branch_id
          )
        );

        if (!currentBranchAvailable && branches.length > 0) {
          setForm2((prev) => ({
            ...prev,
            ysb_branch_id: safeValue(branches[0]?.branch_code),
            ysb_school_id: "",
            ysb_grade_level_id: "",
            ysb_kelas_id: "",
          }));
        }
      }

      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data?.data || [];

        setGetDataSemesterMap(semesters);

        /*
         * Apabila semester murid tidak tersedia,
         * gunakan semester pertama sebagai cadangan.
         */
        const currentSemesterAvailable = semesters.some((semester) =>
          isSameValue(
            semester?.id,
            initialStudentData.current.ysb_semester_id
          )
        );

        if (!currentSemesterAvailable && semesters.length > 0) {
          setForm2((prev) => ({
            ...prev,
            ysb_semester_id: safeValue(semesters[0]?.id),
          }));
        }
      }
    } catch (error) {
      console.error(error);

      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Gagal memuat data semester dan cabang",
        icon: "error",
      });
    }
  }, [
    page,
    limit,
    ascending,
    descending,
    keyword,
    storageBranchGroping,
    storageLevel,
    fetchParams,
  ]);

  /*
   * Saat modal dibuka, langsung isi semua select
   * menggunakan data murid yang dipilih.
   */
  useEffect(() => {
    if (!props.show || !dataUpdate) {
      return;
    }

    const studentData = {
      ysb_semester_id: safeValue(dataUpdate?.ysb_semester_id),
      ysb_branch_id: safeValue(dataUpdate?.ysb_branch_id),
      ysb_school_id: safeValue(dataUpdate?.ysb_school_id),
      ysb_grade_level_id: safeValue(
        dataUpdate?.ysb_grade_level_id
      ),
      ysb_kelas_id: safeValue(dataUpdate?.ysb_kelas_id),
    };

    initialStudentData.current = studentData;
    isInitializing.current = true;

    setForm2(studentData);

    setGetDataSemesterMap([]);
    setGetDataBranch([]);
    setGetDataSchool([]);
    setGetDataLevel([]);
    setGetDataKelas([]);

    fetchInit();
  }, [props.show, dataUpdate, fetchInit]);

  /*
   * Mengambil sekolah berdasarkan cabang.
   */
  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      if (!branchId) {
        setGetDataSchool([]);
        setGetDataLevel([]);
        setGetDataKelas([]);
        return;
      }

      setLoadingSchool(true);

      try {
        const response = await APIMS.get(
          `/api/access/schools-config?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        const schools = response.data?.data || [];

        setGetDataSchool(schools);

        const currentData = initialStudentData.current;

        /*
         * Hanya mempertahankan sekolah murid ketika
         * modal pertama kali dibuka dan cabangnya sama.
         */
        const shouldUseCurrentSchool =
          isInitializing.current &&
          isSameValue(
            branchId,
            currentData.ysb_branch_id
          );

        const currentSchool = shouldUseCurrentSchool
          ? schools.find((school) =>
              isSameValue(
                school?.school_code,
                currentData.ysb_school_id
              )
            )
          : null;

        const selectedSchoolId = safeValue(
          currentSchool?.school_code ||
            schools[0]?.school_code
        );

        setForm2((prev) => ({
          ...prev,

          ysb_school_id: selectedSchoolId,

          /*
           * Jika sekolah murid ditemukan,
           * pertahankan tingkatan dan kelasnya.
           */
          ysb_grade_level_id:
            currentSchool && shouldUseCurrentSchool
              ? currentData.ysb_grade_level_id
              : "",

          ysb_kelas_id:
            currentSchool && shouldUseCurrentSchool
              ? currentData.ysb_kelas_id
              : "",
        }));

        if (schools.length === 0) {
          setGetDataLevel([]);
          setGetDataKelas([]);

          isInitializing.current = false;
        }
      } catch (error) {
        console.error(error);

        setGetDataSchool([]);
        setGetDataLevel([]);
        setGetDataKelas([]);

        setForm2((prev) => ({
          ...prev,
          ysb_school_id: "",
          ysb_grade_level_id: "",
          ysb_kelas_id: "",
        }));

        isInitializing.current = false;
      } finally {
        setLoadingSchool(false);
      }
    },
    [
      page,
      limit,
      ascending,
      storageLevel,
      fetchParams,
    ]
  );

  /*
   * Mengambil tingkatan berdasarkan sekolah.
   */
  const fetchLevelsBySchool = useCallback(
    async (schoolId, branchId) => {
      if (!schoolId) {
        setGetDataLevel([]);
        setGetDataKelas([]);
        return;
      }

      setLoadingLevel(true);

      try {
        const response = await APIMS.get(
          `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        let levels = response.data?.data || [];

        levels = levels.filter((level) =>
          isSameValue(
            level?.ysb_school_id,
            schoolId
          )
        );

        setGetDataLevel(levels);

        const currentData = initialStudentData.current;

        /*
         * Saat modal pertama dibuka, cari tingkatan
         * yang sama dengan tingkatan murid saat ini.
         */
        const shouldUseCurrentLevel =
          isInitializing.current &&
          isSameValue(
            branchId,
            currentData.ysb_branch_id
          ) &&
          isSameValue(
            schoolId,
            currentData.ysb_school_id
          );

        const currentLevel = shouldUseCurrentLevel
          ? levels.find((level) =>
              isSameValue(
                level?.id,
                currentData.ysb_grade_level_id
              )
            )
          : null;

        const selectedLevelId = safeValue(
          currentLevel?.id || levels[0]?.id
        );

        setForm2((prev) => ({
          ...prev,

          ysb_grade_level_id: selectedLevelId,

          ysb_kelas_id:
            currentLevel && shouldUseCurrentLevel
              ? currentData.ysb_kelas_id
              : "",
        }));

        if (levels.length === 0) {
          setGetDataKelas([]);
          isInitializing.current = false;
        }
      } catch (error) {
        console.error(error);

        setGetDataLevel([]);
        setGetDataKelas([]);

        setForm2((prev) => ({
          ...prev,
          ysb_grade_level_id: "",
          ysb_kelas_id: "",
        }));

        isInitializing.current = false;
      } finally {
        setLoadingLevel(false);
      }
    },
    [
      page,
      limit,
      ascending,
      storageLevel,
      fetchParams,
    ]
  );

  /*
   * Mengambil kelas berdasarkan tingkatan.
   */
  const fetchKelasByLevel = useCallback(
    async (
      gradeLevelId,
      schoolId,
      branchId
    ) => {
      if (!gradeLevelId) {
        setGetDataKelas([]);
        return;
      }

      setLoadingKelas(true);

      try {
        const response = await APIMS.get(
          `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        let kelas = response.data?.data || [];

        kelas = kelas.filter(
          (item) =>
            isSameValue(
              item?.ysb_grade_level_id,
              gradeLevelId
            ) &&
            isSameValue(
              item?.ysb_school_id,
              schoolId
            )
        );

        /*
         * Tetap urutkan nama kelas.
         */
        kelas = [...kelas].sort((a, b) =>
          safeValue(a?.name_kelas).localeCompare(
            safeValue(b?.name_kelas),
            "id",
            {
              numeric: true,
              sensitivity: "base",
            }
          )
        );

        setGetDataKelas(kelas);

        const currentData = initialStudentData.current;

        /*
         * Saat modal pertama dibuka, cari kelas
         * yang sama dengan kelas murid saat ini.
         */
        const shouldUseCurrentKelas =
          isInitializing.current &&
          isSameValue(
            branchId,
            currentData.ysb_branch_id
          ) &&
          isSameValue(
            schoolId,
            currentData.ysb_school_id
          ) &&
          isSameValue(
            gradeLevelId,
            currentData.ysb_grade_level_id
          );

        const currentKelas = shouldUseCurrentKelas
          ? kelas.find((item) =>
              isSameValue(
                item?.id,
                currentData.ysb_kelas_id
              )
            )
          : null;

        const selectedKelasId = safeValue(
          currentKelas?.id || kelas[0]?.id
        );

        setForm2((prev) => ({
          ...prev,
          ysb_kelas_id: selectedKelasId,
        }));

        /*
         * Proses otomatis selesai.
         * Setelah ini user bebas mengganti select.
         */
        isInitializing.current = false;
      } catch (error) {
        console.error(error);

        setGetDataKelas([]);

        setForm2((prev) => ({
          ...prev,
          ysb_kelas_id: "",
        }));

        isInitializing.current = false;
      } finally {
        setLoadingKelas(false);
      }
    },
    [
      page,
      limit,
      ascending,
      storageLevel,
      fetchParams,
    ]
  );

  /*
   * Ketika cabang berubah, ambil sekolah.
   */
  useEffect(() => {
    if (form2.ysb_branch_id) {
      fetchSchoolsByBranch(
        form2.ysb_branch_id
      );
    }
  }, [
    form2.ysb_branch_id,
    fetchSchoolsByBranch,
  ]);

  /*
   * Ketika sekolah berubah, ambil tingkatan.
   */
  useEffect(() => {
    if (form2.ysb_school_id) {
      fetchLevelsBySchool(
        form2.ysb_school_id,
        form2.ysb_branch_id
      );
    }
  }, [
    form2.ysb_school_id,
    form2.ysb_branch_id,
    fetchLevelsBySchool,
  ]);

  /*
   * Ketika tingkatan berubah, ambil kelas.
   */
  useEffect(() => {
    if (form2.ysb_grade_level_id) {
      fetchKelasByLevel(
        form2.ysb_grade_level_id,
        form2.ysb_school_id,
        form2.ysb_branch_id
      );
    }
  }, [
    form2.ysb_grade_level_id,
    form2.ysb_school_id,
    form2.ysb_branch_id,
    fetchKelasByLevel,
  ]);

  /*
   * User masih bisa memilih semua select.
   * Select di bawahnya akan di-reset agar
   * datanya sesuai dengan pilihan terbaru.
   */
  const handleChange = (event) => {
    const { name, value } = event.target;

    isInitializing.current = false;

    if (name === "ysb_branch_id") {
      setGetDataSchool([]);
      setGetDataLevel([]);
      setGetDataKelas([]);

      setForm2((prev) => ({
        ...prev,
        ysb_branch_id: value,
        ysb_school_id: "",
        ysb_grade_level_id: "",
        ysb_kelas_id: "",
      }));

      return;
    }

    if (name === "ysb_school_id") {
      setGetDataLevel([]);
      setGetDataKelas([]);

      setForm2((prev) => ({
        ...prev,
        ysb_school_id: value,
        ysb_grade_level_id: "",
        ysb_kelas_id: "",
      }));

      return;
    }

    if (name === "ysb_grade_level_id") {
      setGetDataKelas([]);

      setForm2((prev) => ({
        ...prev,
        ysb_grade_level_id: value,
        ysb_kelas_id: "",
      }));

      return;
    }

    setForm2((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = useMutation(
    async (event) => {
      event.preventDefault();

      // setLoading(true);

      try {
        const payload = {
          /*
           * Data kelas lama.
           */
          ysb_semester_id:
            dataUpdate?.ysb_semester_id,

          ysb_branch_id:
            dataUpdate?.ysb_branch_id,

          ysb_school_id:
            dataUpdate?.ysb_school_id,

          ysb_grade_level_id:
            dataUpdate?.ysb_grade_level_id,

          ysb_kelas_id:
            dataUpdate?.ysb_kelas_id,

          ysb_student_id:
            dataUpdate?.ysb_student_id,

          /*
           * Data kelas tujuan.
           */
          ysb_semester_id_switch:
            form2.ysb_semester_id,

          ysb_branch_id_switch:
            form2.ysb_branch_id,

          ysb_school_id_switch:
            form2.ysb_school_id,

          ysb_grade_level_id_switch:
            form2.ysb_grade_level_id,

          ysb_kelas_id_switch:
            form2.ysb_kelas_id,

          user_id: output_id_user,
        };

        const response = await APILA.post(
          "/api/semester-assignments/switch-student",
          payload,
          fetchParams
        );

        if (response?.status === 200) {
          ToastSuccess.fire({
            icon: "success",
            title:
              response.data?.message ||
              "Siswa berhasil dipindahkan",
          });

          props.GetResponseData?.();
          props.onHide();
        }
      } catch (error) {
        swal({
          title: "Gagal",
          text:
            error?.response?.data?.message ||
            "Terjadi kesalahan",
          icon: "error",
          timer: 8000,
        });
      } finally {
        setLoading(false);
      }
    }
  );

  const isFormComplete =
    form2.ysb_semester_id &&
    form2.ysb_branch_id &&
    form2.ysb_school_id &&
    form2.ysb_grade_level_id &&
    form2.ysb_kelas_id;

  return (
    <Modal
      {...props}
      size="lg"
      centered
    >
      {loading && <LoaderAction />}

      <div className="d-flex header-modal">
        <h5>Pindah Kelas Siswa</h5>

        <div className="ml-auto x-close">
          <FontAwesomeIcon
            icon={faXmark}
            onClick={props.onHide}
            style={{
              cursor: "pointer",
            }}
          />
        </div>
      </div>

      <hr />

      <Modal.Body
        style={{
          fontSize: 13,
        }}
      >
        <Form
          onSubmit={(event) =>
            handleSubmit.mutate(event)
          }
        >
          <div className="mb-4 p-3 border rounded bg-light">
            <h6
              className="mb-3 pb-2 border-bottom"
              style={{
                fontSize: 14,
              }}
            >
              <strong>
                Data Siswa Saat Ini
              </strong>
            </h6>

            <div className="row">
              <div className="col-12">
                <table
                  className="table table-borderless table-sm mb-0"
                  style={{
                    tableLayout: "fixed",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          width: "140px",
                        }}
                      >
                        <strong>Semester</strong>
                      </td>

                      <td
                        style={{
                          width: "10px",
                        }}
                      >
                        :
                      </td>

                      <td>
                        {dataUpdate?.name_semester}{" "}
                        Semester{" "}
                        {dataUpdate?.number_semester}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <strong>Cabang</strong>
                      </td>

                      <td>:</td>

                      <td>
                        {dataUpdate?.name_branch}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <strong>Sekolah</strong>
                      </td>

                      <td>:</td>

                      <td>
                        {dataUpdate?.name_school}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <strong>
                          Nama Siswa
                        </strong>
                      </td>

                      <td>:</td>

                      <td className="fw-bold">
                        {dataUpdate?.name_student}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <strong>
                          Kelas Saat Ini
                        </strong>
                      </td>

                      <td>:</td>

                      <td>
                        {dataUpdate?.number_kelas}{" "}
                        {dataUpdate?.name_kelas}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-md-6">
              <label>
                Semester Tujuan
              </label>

              <select
                className="form-select"
                name="ysb_semester_id"
                value={
                  form2.ysb_semester_id
                }
                onChange={handleChange}
                required
                style={{
                  fontSize: 13,
                }}
              >
                <option value="">
                  Pilih Semester
                </option>

                {getDataSemesterMap.map(
                  (semester) => (
                    <option
                      key={semester.id}
                      value={safeValue(
                        semester.id
                      )}
                    >
                      {semester.name_year}{" "}
                      (Semester{" "}
                      {semester.semester})
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="col-md-6">
              <label>
                Cabang Tujuan
              </label>

              <select
                className="form-select"
                name="ysb_branch_id"
                value={
                  form2.ysb_branch_id
                }
                onChange={handleChange}
                required
                style={{
                  fontSize: 13,
                }}
              >
                <option value="">
                  Pilih Cabang
                </option>

                {getDataBranch.map(
                  (branch) => (
                    <option
                      key={
                        branch.branch_code
                      }
                      value={safeValue(
                        branch.branch_code
                      )}
                    >
                      {branch.branch_name}
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="col-md-6">
              <label>
                Sekolah Tujuan
              </label>

              <select
                className="form-select"
                name="ysb_school_id"
                value={
                  form2.ysb_school_id
                }
                onChange={handleChange}
                disabled={
                  loadingSchool ||
                  !form2.ysb_branch_id
                }
                required
                style={{
                  fontSize: 13,
                }}
              >
                <option value="">
                  {loadingSchool
                    ? "Memuat..."
                    : "Pilih Sekolah"}
                </option>

                {getDataSchool.map(
                  (school) => (
                    <option
                      key={
                        school.school_code
                      }
                      value={safeValue(
                        school.school_code
                      )}
                    >
                      {school.school_name}
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="col-md-6">
              <label>
                Tingkatan Tujuan
              </label>

              <select
                className="form-select"
                name="ysb_grade_level_id"
                value={
                  form2.ysb_grade_level_id
                }
                onChange={handleChange}
                disabled={
                  loadingLevel ||
                  !form2.ysb_school_id
                }
                required
                style={{
                  fontSize: 13,
                }}
              >
                <option value="">
                  {loadingLevel
                    ? "Memuat..."
                    : "Pilih Tingkatan"}
                </option>

                {getDataLevel.map(
                  (level) => (
                    <option
                      key={level.id}
                      value={safeValue(
                        level.id
                      )}
                    >
                      {level.name_level}
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="col-12">
              <label>
                Kelas Tujuan
              </label>

              <select
                className="form-select"
                name="ysb_kelas_id"
                value={
                  form2.ysb_kelas_id
                }
                onChange={handleChange}
                disabled={
                  loadingKelas ||
                  !form2.ysb_grade_level_id
                }
                required
                style={{
                  fontSize: 13,
                }}
              >
                <option value="">
                  {loadingKelas
                    ? "Memuat..."
                    : "Pilih Kelas"}
                </option>

                {getDataKelas.map(
                  (kelas) => (
                    <option
                      key={kelas.id}
                      value={safeValue(
                        kelas.id
                      )}
                    >
                      {kelas.name_kelas}
                    </option>
                  )
                )}
              </select>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-4">
            <Button
              className="btn-modal-create"
              type="submit"
              disabled={
                loading ||
                !isFormComplete
              }
            >
              {loading
                ? "Memproses..."
                : "Pindahkan Siswa"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}